import React from 'react';
import { StyledVoiceTag } from './index.style';
import ImportantTag from '../ImportantTag';

const VoiceTag = ({ getLabels }) => (
  <StyledVoiceTag>
    {getLabels?.map((tag, index) => (
      <ImportantTag
        icon={tag?.icon}
        ket={index}
        tag={tag?.title}
        cancelAbsolute
        padding="4px 12px"
        borderRadius="0px 0px 8px 8px"
        bgColor={tag.bgColor}
        color={tag?.textColor}
        contentTooltip={tag?.contentTooltip}
      />
    ))}
  </StyledVoiceTag>
);

export default VoiceTag;
